export default "__VITE_PUBLIC_ASSET__9d26672e__"